import * as React from 'react';

function SvgAllBook(props) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.625 7.148h-6V4.5a.75.75 0 00-.75-.75H4.312v-.938a.188.188 0 00-.187-.187H2.812a.188.188 0 00-.187.188v18.375c0 .103.084.187.188.187h1.312a.188.188 0 00.188-.188V15h5.812v2.648c0 .415.335.75.75.75h9.75a.75.75 0 00.75-.75v-9.75a.75.75 0 00-.75-.75z"
        fill="#F9A600"
      />
    </svg>
  );
}

export default SvgAllBook;
